import { Controller } from "@hotwired/stimulus";

// Disables the composer action buttons (picture, gif, …) once the shared
// attachment strip reaches the limit. File previews (.dz-preview) and gif
// previews (.comment-attachment-preview) both live in the same container and
// count toward the same Post::MAX_ATTACHMENTS limit, so we count the DOM tiles.
export default class extends Controller {
  static targets = ["previews", "action"];
  static values = { max: { type: Number, default: 5 } };

  connect() {
    this.observer = new MutationObserver(() => this.update());
    if (this.hasPreviewsTarget) {
      this.observer.observe(this.previewsTarget, { childList: true });
    }
    this.update();
  }

  disconnect() {
    this.observer?.disconnect();
  }

  update() {
    const reached = this.#count() >= this.maxValue;
    this.actionTargets.forEach((button) => {
      button.disabled = reached;
      button.setAttribute("aria-disabled", reached ? "true" : "false");
    });
  }

  #count() {
    if (!this.hasPreviewsTarget) return 0;
    return this.previewsTarget.querySelectorAll(
      ".dz-preview, .comment-attachment-preview"
    ).length;
  }
}
